import {createRoot} from 'react-dom/client'
import App from './App.tsx'
import './index.css'
// i18n initialization moved to initializeApp() to prevent race condition
// (was loading translations before runtime config was ready)
import {appConfig} from './core/config'
import {updateApiConstants} from './core/api-config'

/**
 * Initialize application with runtime configuration
 */
async function initializeApp() {
    console.log('🚀 Initializing application...');

    // Step 1: Load runtime configuration first
    console.log('⏳ Step 1: Loading runtime config...');
    await appConfig.loadRuntimeConfig();
    console.log('✅ Step 1 complete: Runtime config loaded');

    // Step 2: Update API constants with runtime config
    console.log('⏳ Step 2: Updating API constants...');
    updateApiConstants();
    console.log('✅ Step 2 complete: API constants updated');

    // Step 3: Initialize i18n AFTER config is ready
    console.log('⏳ Step 3: Initializing i18n...');
    await import('@/core/i18n/i18n-config');
    console.log('✅ Step 3 complete: i18n initialized with correct URLs');

    // Add global dev utilities in development mode
    if (appConfig.isDevelopment()) {
        // Make config available globally for debugging
        (window as any).appConfig = appConfig;

        // Log initial configuration
        appConfig.logConfig();

        // Add helpful dev utilities
        (window as any).devUtils = {
            showConfig: () => appConfig.logConfig(),
        };

        console.log('🛠️ Dev utilities available: window.appConfig, window.devUtils');
    }

    // Render the app
    console.log('🎉 Application initialization complete, rendering app...');
    createRoot(document.getElementById("root")!).render(<App/>);
}

// Initialize the app
initializeApp().catch((error) => {
    console.error('Failed to initialize app:', error);
    // Render anyway with fallback config
    createRoot(document.getElementById("root")!).render(<App/>);
});
